<template>
  <SDatesSelection
    :outwardState="getOutwardState"
    :returnState="getReturnState"
    :tripType="getTripType"
    :minTimeBeforeBooking="getMinTimeBeforeBooking"
    :maxNumberOfDaysForFutureBooking="getMaxNumberOfDaysForFutureBooking"
    :allowOnDemandPickUpTime="allowOnDemandPickUpTime"
    :workingHoursZoneWeekDays="getWorkingHoursZoneWeekDays"
    :holidays="getHolidays"
    :timeZone="getTimeZone"
    @clearDates="clearDates"
    @setOutwardDate="setOutwardDate"
    @setReturnDate="setReturnDate"
    @trackGtmEventApplyDateAndTimeForOutward="onTrackEventApplyDateAndTimeForOutward"
    @trackGtmEventApplyDateAndTimeForReturn="onTrackEventApplyDateAndTimeForReturn"
  />
</template>
<script lang="ts">
export default {
  name: 'DatesSelection',
};
</script>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { SDatesSelection } from '@slg/web-customer-shared';
import { useStore, useGtm } from '@/composables';

const emit = defineEmits(['clearBookingRequestError']);
const store = useStore();
const { trackGtmEvent } = useGtm();

const currentComponent = ref<string | undefined>(undefined);
const isDialogOpen = ref(false);

const getReturnTime = computed(() => store.getters['booking/getReturnTime']);
const getOutwardState = computed(() => store.getters['booking/getOutwardState']);
const getReturnState = computed(() => store.getters['booking/getReturnState']);
const getHolidays = computed(() => store.getters['opsZone/getHolidays']);
const getTripType = computed(() => store.getters['booking/getTripType']);
const getMinTimeBeforeBooking = computed(() => store.getters['opsZone/getMinTimeBeforeBooking']);
const getMaxNumberOfDaysForFutureBooking = computed(() => store.getters['opsZone/getMaxNumberOfDaysForFutureBooking']);
const allowOnDemandPickUpTime = computed(() => store.getters['opsZone/allowOnDemandPickUpTime']);
const getWorkingHoursZoneWeekDays = computed(() => store.getters['opsZone/getWorkingHoursZoneWeekDays']);
const getTimeZone = computed(() => store.getters['opsZone/getTimeZone']);

function clearDates() {
  store.commit('booking/clearDates');
}

function setOutwardDate(outwardDate: unknown) {
  store.commit('booking/setOutwardDate', outwardDate);
  emit('clearBookingRequestError');
}

function setReturnDate(returnDate: unknown) {
  store.commit('booking/setReturnDate', returnDate);
  emit('clearBookingRequestError');
}

function openDialog(name: string) {
  currentComponent.value = name;
  isDialogOpen.value = true;
}

function changeStep(name: string) {
  currentComponent.value = name;
}

function closeDialog() {
  isDialogOpen.value = false;
}

function onTrackEventApplyDateAndTimeForOutward() {
  trackGtmEvent('Apply date and time for outward trip button click', 'Button', 'Click', 'Date and Time for outward trip selected');
}

function onTrackEventApplyDateAndTimeForReturn() {
  trackGtmEvent('Apply date and time for return trip button click', 'Button', 'Click', 'Date and Time for return trip selected');
}
</script>
<style lang="scss" scoped>
</style>
